import { h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';
import { isPowsterEmployee } from 'utils/roles';

import UniversalMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversal';

export default class UniversalBaseMovieMediaEditor extends UniversalMovieMediaEditor {

	constructor(props) {
		super(props);

		// Ensure the hero type is set to 'video' if it doesn't already exist.
		const heroTypePath = `${this.props.dataRoot}/content/hero/type`;
		if (!jsonPointer.has(Store.get().data, heroTypePath)) {
			jsonPointer.setDeep(Store.get().data, heroTypePath, 'video');
		}
	}

	renderDescription() {
		const base = super.renderDescription();
		base.push(<p>Media added here will be made available across all locales.</p>);
		return base;
	}

	renderHeroImage() {
		return super.renderHeroImage({
			hideAlt: true,
		});
	}

	renderGallery() {
		return super.renderGallery({
			extraSettings: null,
			altPlaceholder: null,
			hideAlt: true,
		});
	}

	renderFooterLogos() {
		return super.renderFooterLogos({
			hideAlt: true,
		});
	}

	getSections() {
		const showMiscAssets = isPowsterEmployee() || Object.keys(this.movie?.miscAssets || {}).length > 0;

		return [
			{ label: 'Supporting assets', content: [this.renderFavicon()] },
			{ label: 'Hero', note: 'Select either a video or image background for the hero section on the landing page', content: this.renderSectionHero() },
			{ label: 'Gallery', note: 'Drag to reorder', content: this.renderGallery() },
			{ label: 'Footer logos', note: 'Drag to reorder', content: this.renderFooterLogos() },
			showMiscAssets && { label: 'Miscellaneous assets', note: 'Assets used for custom implementations', content: this.renderMiscAssets() },
		].filter(Boolean);
	}
}